'use client';

import { LoginWithRedirectOptions, useCommonAuthProvider } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';
import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';
import { AbsoluteSpinner } from 'app/_components/AbsoluteSpinner';

import React, { useEffect } from 'react';

export const AuthGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isAuthenticated, user, isLoading, login } = useCommonAuthProvider();
  const [isRedirecting, setRedirecting] = React.useState(false);
  const { cloudMspEnableUiFeatures } = useFlagsProxy();

  useEffect(() => {
    if (isLoading || isRedirecting) {
      return;
    }

    if (!isAuthenticated) {
      setRedirecting(true);

      const loginParams: LoginWithRedirectOptions = { returnTo: window.location.toString() };

      if (cloudMspEnableUiFeatures) {
        const params = new URLSearchParams(window.location.search);
        const connection = params.get('connection');

        if (connection) {
          loginParams.connection = connection;
        }

        const loginHint = params.get('login_hint');

        if (loginHint) {
          loginParams.loginHint = loginHint;
        }
      }

      login(loginParams);
    }
  }, [isAuthenticated, isLoading]);

  if (isRedirecting || isLoading || !isAuthenticated || !user) {
    return <AbsoluteSpinner />;
  }

  return <>{children}</>;
};
